import gql from "graphql-tag";

export default gql`
  mutation ValidateTicketData($input: ValidateTicketInput) {
    validateTicket(input: $input) {
      __typename
      ... on Error {
        message
      }
      ... on InvalidTicketValidationError {
        grantedTicketIdError
        notEnoughEntriesError
      }
      ... on GrantedTicket {
        id
        timesUsed
        ticketCollection {
          serviceProvider {
            name
          }
          ticket {
            title
            canBeUsedBy
            validTo
            validFrom
            entryLimit
            description
          }
        }
      }
    }
  }
`;
